<template>
  <div class="heroBlock">
    <v-carousel cycle dark height="400">
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      >
        <v-row class="title fill-height hidden-xs-only" align="center" justify="center">{{ item.title }}</v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: "Qualities",
  data() {
    return {
      items: [
        {
         
          src: require("../assets/images/creative.jpg"),
          title: "I am creative"
        },
        {
        
          src: require("../assets/images/hard_worker.jpg"),
          title: "I am hard worker"
        },
        {
         
          src: require("../assets/images/professional.jpg"),
          title: "I am professional"
        }
      ]
    };
  }
};
</script>